import { PublicShell } from './layout.tsx';
import { Button, PageTitle } from './ui.tsx';

/*
 * Letzte Anzeige, wenn eine Seite nicht steht. In der installierten App gibt es keine
 * Adressleiste und auf dem iPhone keine Zurück-Taste, darum führt hier immer ein Weg weiter.
 * Die Ursache schreibt React selbst in die Konsole (`onCaughtError`), hier steht sie nie.
 *
 * Die Startseite ist ein echter Link statt `Link`: Fehlt ein Chunk, hilft nur frisch
 * geladener Code.
 */

/** Für Seiten in der `AppShell`: Der Rahmen steht noch, die Navigation bleibt nutzbar. */
export function RouteErrorNote() {
  return (
    <div role="alert">
      <PageTitle lead="Bitte laden Sie neu. Hilft das nicht, versuchen Sie es über die Startseite oder später noch einmal.">Seite lässt sich nicht anzeigen</PageTitle>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => window.location.reload()}>Neu laden</Button>
        <a href="/" className="ad-button-outline">
          Zur Startseite
        </a>
      </div>
    </div>
  );
}

export function NotFoundNote() {
  return (
    <>
      <PageTitle lead="Diese Adresse gibt es nicht. Der Link ist vielleicht veraltet oder unvollständig.">Seite nicht gefunden</PageTitle>
      <a href="/" className="ad-button-primary">
        Zur Startseite
      </a>
    </>
  );
}

/** Für alles außerhalb der `AppShell`, auch wenn sie selbst gescheitert ist. */
export function PublicRouteErrorNote() {
  return (
    <PublicShell>
      <RouteErrorNote />
    </PublicShell>
  );
}

export function PublicNotFoundNote() {
  return (
    <PublicShell>
      <NotFoundNote />
    </PublicShell>
  );
}
